<template>
    <portal
        v-if="isOpen"
        to="modals"
    >
        <modal-backdrop
            :is-open="isOpen"
            @close="close"
        >
            <modal-window
                :is-open="isOpen"
                :class="`max-w-${maxW}`"
                @close="close"
            >
                <div class="relative bg-white w-full rounded shadow-lg">
                    <div class="absolute top-0 inset-x-0 bg-blue h-1 rounded-t" />

                    <slot :close="close" />
                </div>
            </modal-window>
        </modal-backdrop>
    </portal>
</template>

<script>
    import ModalBackdrop from './modal-backdrop'
    import ModalWindow from './modal-window.vue'

    export default {
        components: {
            ModalBackdrop,
            ModalWindow
        },
        props: {
            isOpen: {
                type: Boolean,
                required: true
            },
            maxW: {
                type: String,
                default: 'sm'
            }
        },
        methods: {
            close () {
                this.$emit('close', false)
            }
        }
    }
</script>
